import angular from 'angular';
import 'angular-bootstrap';
import locales from '../../locale';
import './gamificationsServices';

const gamificationsControllers = angular.module('applicationModule.gamificationsControllers', [
    'ngAnimate',
    'applicationModule.gamificationsServices',
    'ui.bootstrap'
]);

// Gamifications Index Controller
gamificationsControllers.controller('GamificationsIndexController', ['$scope', '$rootScope', '$stateParams', '$state', 'Permissions', function ($scope, $rootScope, $stateParams, $state, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('gamifications');
    $scope.application_id = $stateParams.application_id;

    $scope.showActions = function () {
        $state.go('appsoup.application.gamifications.actions');
    };

    $scope.showBadges = function () {
        $state.go('appsoup.application.gamifications.badges');
    };

}]);

// Gamifications Actions List Controller
gamificationsControllers.controller('GamificationsActionsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'GamificationActions', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, GamificationActions, growl, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('gamifications');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return GamificationActions.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.actions.total);
                    params.count(response.actions.per_page);
                    params.page(response.actions.current_page);
                    return response.actions.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeAction = function (id, index) {
        GamificationActions.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.SUCCESS.DELETE');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.ERROR.DELETE');
                }
            });
    };
}]);

// Gamifications Action Page Controller
gamificationsControllers.controller('GamificationsActionPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'GamificationActions', 'growl', 'Permissions', function ($scope, $rootScope, $state, $stateParams, GamificationActions, growl, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('gamifications');
    $scope.application_id = $stateParams.application_id;

    $scope.editMode = false;

    $scope.action = {};

    const appId = $stateParams.application_id;

    $scope.action.app_id = appId;

    $scope.types = [];
    $scope.beacons = [];

    GamificationActions.getTypes(appId)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.types = data.types;
                $scope.beacons = data.beacons;
                $scope.allBeacons = data.beacons;
            }
        });

    if (angular.isDefined($stateParams.actionId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;
        const actionId = $stateParams.actionId;
        GamificationActions.get(actionId, appId)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.action = data.action;
                    $scope.levelBeacon = data.levelBeacon;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.' + data.error);
                }
            })
            .catch(function () {
                $state.go('appsoup.application.gamifications.actions', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.selectedType = function (type) {
        if (type !== 1) {
            $scope.beacons = [];
            angular.forEach($scope.allBeacons, function (val, key) {
                if (val.type === 1) {
                    $scope.beacons.push($scope.allBeacons[key]);
                }
            });
        } else {
            $scope.beacons = $scope.allBeacons;
        }
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.action.application_id = appId;
        $scope.isLoading = true;
        GamificationActions.save($scope.action, $scope.editMode)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileError = false;
                    if ($scope.editMode) {
                        growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.SUCCESS.EDITED');
                    } else {
                        growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.SUCCESS.CREATED');
                    }
                    $state.go('appsoup.application.gamifications.actions', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.gamifications.actions', {application_id: appId});
    };

    $scope.changeParam = function (selectedLevelBeacon) {
        $scope.action.param = selectedLevelBeacon.id;
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.ERROR.REQUIRE.NAME'}],
        'type': [{type: '$invalid', msg: 'ERROR.REQUIRE.TYPE'}],
        'param': [{error: 'required', msg: 'ERROR.REQUIRE.PARAM'}, {
            error: 'pattern',
            msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.ERROR.PARAM_PATTERN'
        }]
    };
}]);

// Gamifications Badges List Controller
gamificationsControllers.controller('GamificationsBadgesListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'GamificationBadges', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, GamificationBadges, growl, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('gamifications');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return GamificationBadges.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.badges.total);
                    params.count(response.badges.per_page);
                    params.page(response.badges.current_page);
                    return response.badges.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeBadge = function (id, index) {
        GamificationBadges.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.SUCCESS.DELETE');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.DELETE');
                }
            });
    };
}]);

// Gamifications Badges Page Controller
gamificationsControllers.controller('GamificationsBadgePageController', ['$scope', '$rootScope', '$state', '$stateParams', 'GamificationBadges', 'growl', 'Permissions', function ($scope, $rootScope, $state, $stateParams, GamificationBadges, growl, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('gamifications');
    $scope.application_id = $stateParams.application_id;
    const badgeId = $stateParams.badgeId;

    $scope.editMode = false;

    const appId = $stateParams.application_id;

    $scope.badge = {
        app_id: appId
    };

    $scope.actions = [];

    GamificationBadges.getActions(appId)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.actions = data.actions;
            }
        });

    if (angular.isDefined(badgeId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;

        GamificationBadges.get(badgeId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.badge = data.badge;

                if ($scope.badge.in_order === true) {
                    $scope.badge.in_order = 1;
                }
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.gamifications.badges', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $rootScope.doingResolve = false;
        });
    }

    $scope.roundedCount = function (count) {
        return Math.round(count);
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.badgeForm.$valid) {
            $scope.badge.application_id = appId;
            $scope.isLoading = true;

            if (angular.isUndefinedNullOrEmpty($scope.badge.action_1)) {
                $scope.badge.action_1 = null;
            }
            if (angular.isUndefinedNullOrEmpty($scope.badge.count_1)) {
                $scope.badge.count_1 = null;
            }
            if (angular.isUndefinedNullOrEmpty($scope.badge.action_2)) {
                $scope.badge.action_2 = null;
            }
            if (angular.isUndefinedNullOrEmpty($scope.badge.count_2)) {
                $scope.badge.count_2 = null;
            }
            if (angular.isUndefinedNullOrEmpty($scope.badge.action_3)) {
                $scope.badge.action_3 = null;
            }
            if (angular.isUndefinedNullOrEmpty($scope.badge.count_3)) {
                $scope.badge.count_3 = null;
            }

            GamificationBadges.save($scope.badge, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    if ($scope.editMode) {
                        growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.SUCCESS.EDITED');
                    } else {
                        growl.success('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.SUCCESS.CREATED');
                    }
                    $state.go('appsoup.application.gamifications.badges', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.count_1 || data.error.count_2 || data.error.count_3) {
                            $scope.formErrors = growl.error('MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.COUNT');
                        } else {
                            $scope.formErrors = data.error;
                        }
                    } else {
                        growl.error('MODULES.GAMIFICATIONS.BADGES.ERROR.CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.gamifications.badges', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.REQUIRE.NAME'}],
        'action_1': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.REQUIRE.ACTION'}],
        'action_2': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.REQUIRE.NAME'}],
        'action_3': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.REQUIRE.ACTION'}],
        'image': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.ERROR.REQUIRE.IMAGE'}]
    };
}]);

export default gamificationsControllers;
